import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from 'react-select'
import CheckBox from "../common/CheckBox";
import ComboBox from "../common/ComboBox";
import { DatePicker } from "../common/DatePicker";
import { TextBox } from "../common/TextBox";
import { TextBoxEmail } from "../common/TextBoxEmail";

//require("./UserRoles.css");

interface Props {

}

const translationPrefix = 'Support';

const RequestSent = (props: Props) => {
    const { t } = useTranslation(undefined, { keyPrefix: translationPrefix });
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({});

    return (
        <>
            <h2
                style={{
                    textAlign: "center",
                    padding: "50px",
                    fontWeight: "bold",
                    textShadow: "2px 1px #ffd0d0",
                }}
            >
                {t('RequestHasBeenSubmitted')}
            </h2>
        </>
    );
}

export default RequestSent;